import {AfterViewInit, Component, EventEmitter, Input, Output} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {MarkerService} from "../../../services/marker-service.service";
import {HttpClient} from "@angular/common/http";

import * as L from 'leaflet';
// @ts-ignore
import {MarkerClusterGroup} from "leaflet.markercluster";
import {markers} from "../../../model/markers";
import {latLng, MarkerOptions, point} from "leaflet";
import {Article} from "../../../model/article";
import {searchInObjects} from "../../../functions/find";
import {NgForOf, NgIf, NgStyle} from "@angular/common";
import {IconComponent} from "../icon/icon.component";
import {Icon, Icons} from "../../../model/icon";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {environment} from "../../../environments/environment";
import {getUrlImg, logObjectAsConst} from "../../../functions/test";
import {articleNew} from "../../../model/toLoad";
import {PointData} from "../../../model/pointData";

interface Event {
  date: string;
  description: string;
  type: string;
}
@Component({
  selector: 'app-old-map',
  imports: [
    FormsModule,
    NgStyle,
    IconComponent,
    NgForOf,
    NgIf
  ],
  templateUrl: './old-map.component.html',
  styleUrl: './old-map.component.scss',
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [ // Появление
        style({ opacity: 0 }), // Начальное состояние
        animate('200ms ease-in', style({ opacity: 1 })) // Конечное состояние
      ]),
    ])
  ]
})
export class OldMapComponent implements AfterViewInit{
  @Input() filterByTypes: string[] = ['all'];
  @Input() edit: boolean = false;
  @Output() emitActive: EventEmitter<string> = new EventEmitter<string>();
  @Output() emitActiveEdit: EventEmitter<PointData> = new EventEmitter<PointData>();
  @Output() emitNewEdit: EventEmitter<{lat: number, lng: number}> = new EventEmitter<{lat: number, lng: number}>();
  @Output() emitPanorama: EventEmitter<string> = new EventEmitter<string>();
  constructor(private markerService: MarkerService, private http: HttpClient) {}

  ngAfterViewInit() {
    setTimeout(() => {
      this.setIcons();
      this.initMap();
    }, 100);
  }



  iconDisplay: boolean = true;

  private points: L.Marker[] = [];
  private legends: L.Marker[] = [];
  private panoramas: L.Marker[] = [];

  private group: MarkerClusterGroup = new MarkerClusterGroup();

  overlayPositions: {
    top: number,
    left: number,
    width: number,
    height: number,
    lat: number,
    lng: number,
    icon: Icon
  }[] = [
    {
      top: 0,
      left: 0,
      width: 20,
      height: 20,
      lat: 32.11049589629439,
      lng: 56.45874023437501,
      icon: Icons.fist,
    },
    {
      top: 0,
      left: 0,
      width: 20,
      height: 20,
      lat: 24.716895455859337 ,
      lng: 56.50268554687501,
      icon: Icons.star,
    },
    {
      top: 0,
      left: 0,
      width: 20,
      height: 20,
      lat: 16.98324853069067,
      lng: 56.50268554687501,
      icon: Icons.medal,
    },
    {
      top: 0,
      left: 0,
      width: 20,
      height: 20,
      lat: 8.646195681181904 ,
      lng: 56.50268554687501,
      icon: Icons.bomb,
    },
    {
      top: 0,
      left: 0,
      width: 20,
      height: 20,
      lat: 31.87755764334002,
      lng: 83.10058593750001 ,
      icon: Icons.evacuation,
    },
    {
      top: 0,
      left: 0,
      width: 20,
      height: 20,
      lat: 24.647017162630366,
      lng: 83.01269531250001,
      icon: Icons.attention,
    },
    {
      top: 0,
      left: 0,
      width: 20,
      height: 20,
      lat: 17.035777250427195,
      lng: 83.05664062500001,
      icon: Icons.helmet,
    },
    {
      top: 0,
      left: 0,
      width: 20,
      height: 20,
      lat: 8.700499129275828,
      lng: 83.12255859375001,
      icon: Icons.crane,
    },
    {
      top: 0,
      left: 0,
      width: 20,
      height: 20,
      lat: 8.700499129275828,
      lng: 83.12255859375001,
      icon: Icons.crane,
    },
    {
      top: 0,
      left: 0,
      width: 20,
      height: 20,
      lat: 31.98944183792288,
      lng: 110.98388671875001,
      icon: Icons.ashoka,
    },
    {
      top: 0,
      left: 0,
      width: 20,
      height: 20,
      lat: 31.98944183792288,
      lng: 110.98388671875001,
      icon: Icons.ashoka,
    },
    {
      top: 0,
      left: 0,
      width: 20,
      height: 20,
      lat: 24.647017162630366,
      lng: 111.00585937500001,
      icon: Icons.gear,
    },
    {
      top: 0,
      left: 0,
      width: 20,
      height: 20,
      lat: 16.97274101999902,
      lng: 111.02783203125001,
      icon: Icons.train,
    },
    {
      top: 0,
      left: 0,
      width: 20,
      height: 20,
      lat: 16.97274101999902,
      lng: 111.02783203125001,
      icon: Icons.train,
    },
    {
      top: 0,
      left: 0,
      width: 20,
      height: 20,
      lat: 8.51583556120223,
      lng: 110.93994140625001,
      icon: Icons.target,
    },
  ];

  boevoiIcon = L.divIcon({
    className: 'medal',
    html: document.getElementById('medal')?.innerHTML,
    iconSize: [40, 40], // Размер контейнера
    iconAnchor: [20, 40] // Точка привязки
  });

   actionsIcon = L.divIcon({
    className: 'target',
    html: document.getElementById('target')?.innerHTML,
    iconSize: [40, 40], // Размер контейнера
    iconAnchor: [20, 40] // Точка привязки
  });

   air_strikeIcon = L.divIcon({
    className: 'bomb',
    html: document.getElementById('bomb')?.innerHTML,
    iconSize: [40, 40], // Размер контейнера
    iconAnchor: [20, 40] // Точка привязки
  });

   daysIcon = L.divIcon({
    className: 'fist',
    html: document.getElementById('fist')?.innerHTML,
    iconSize: [40, 40], // Размер контейнера
    iconAnchor: [20, 40] // Точка привязки
  });

   recon_trainIcon = L.divIcon({
    className: 'gear',
    html: document.getElementById('gear')?.innerHTML,
    iconSize: [40, 40], // Размер контейнера
    iconAnchor: [20, 40] // Точка привязки
  });

   reserveIcon = L.divIcon({
    className: 'helmet',
    html: document.getElementById('helmet')?.innerHTML,
    iconSize: [40, 40], // Размер контейнера
    iconAnchor: [20, 40] // Точка привязки
  });

   disturbancesIcon = L.divIcon({
    className: 'attention',
    html: document.getElementById('attention')?.innerHTML,
    iconSize: [40, 40], // Размер контейнера
    iconAnchor: [20, 40] // Точка привязки
  });

   infrastructureIcon = L.divIcon({
    className: 'crane',
    html: document.getElementById('crane')?.innerHTML,
    iconSize: [40, 40], // Размер контейнера
    iconAnchor: [20, 40] // Точка привязки
  });

   specialIcon = L.divIcon({
    className: 'ashoka',
    html: document.getElementById('ashoka')?.innerHTML,
    iconSize: [40, 40], // Размер контейнера
    iconAnchor: [20, 40] // Точка привязки
  });

   buildingIcon = L.divIcon({
    className: 'train',
    html: document.getElementById('train')?.innerHTML,
    iconSize: [40, 40], // Размер контейнера
    iconAnchor: [20, 40] // Точка привязки
  });

   achievmentIcon = L.divIcon({
    className: 'star',
    html: document.getElementById('star')?.innerHTML,
    iconSize: [40, 40], // Размер контейнера
    iconAnchor: [20, 40] // Точка привязки
  });

   evacuationIcon = L.divIcon({
    className: 'evacuation',
    html: document.getElementById('evacuation')?.innerHTML,
    iconSize: [40, 40], // Размер контейнера
    iconAnchor: [20, 40] // Точка привязки
  });

   panoramaIcon = L.divIcon({
    className: 'panorama',
    html: document.getElementById('panorama')?.innerHTML,
    iconSize: [40, 40], // Размер контейнера
    iconAnchor: [20, 40] // Точка привязки
  });

  private image = 'app/assets/map';
  private width = 30006;
  private height = 18084;
  private maxLevel = 7;
  private minLevel = 0;
  private orgLevel = 7;

  private tileWidth = 256 * Math.pow(2, this.orgLevel);
  private radius = this.tileWidth / 2 / Math.PI;
  private rx = this.width - this.tileWidth / 2;
  private ry = -this.height + this.tileWidth / 2;

  private west = -180;
  private east = (180 / Math.PI) * (this.rx / this.radius);
  private north = 85.05;
  private south = (360 / Math.PI) * (Math.atan(Math.exp(this.ry / this.radius)) - (Math.PI / 4));

  private rc = (this.tileWidth / 2 + this.ry) / 2;
  private centerLat = (360 / Math.PI) * (Math.atan(Math.exp(this.rc / this.radius)) - (Math.PI / 4));
  private centerLon = (this.west + this.east) / 2;
  private bounds: [number, number][] = [[this.south, this.west], [this.north, this.east]];
  private mbounds: [number, number][] = [[this.south-10, this.west-30], [this.north+10, this.east+30]];

  private map!: L.Map;

  private rippleInterval: any; // Переменная для хранения интервала
  private currentMarker!: L.Marker | null;


  setFilter(arr: string[])  {
    this.filterByTypes = arr;
    this.filter();
  }

  zoomIn() {
    this.map.zoomIn();
  }

  zoomOut() {
    this.map.zoomOut();
  }

  initMap(): void {
    this.map = L.map('map', {
      attributionControl: false,
      maxBounds: this.mbounds
    });

    if (this.edit) {
      // Подписываемся на событие клика по карте
      this.map.on('click', (e: L.LeafletMouseEvent) => {
        const lat = e.latlng.lat;
        const lng = e.latlng.lng;
        this.emitNewEdit.emit({lat: lat, lng: lng});
        // L.marker([lat, lng], {icon: this.daysIcon, title: ""}).addTo(this.map);
      });
    }

    L.tileLayer(this.image + '/{z}-{x}-{y}.jpg', {
      maxZoom: this.maxLevel,
      minZoom: this.minLevel,
      opacity: 1.0,
      zIndex: 1,
      noWrap: true,
      bounds: this.bounds,
      attribution: '',
    }).addTo(this.map);

    const zoom = this.map.getBoundsZoom(this.bounds);
    const center = L.latLng(this.centerLat, this.centerLon);

    const zoomControl = this.map.zoomControl;
    zoomControl.remove();

    this.map.setView(center, zoom);
    this.map.doubleClickZoom.disable();

    this.group = new MarkerClusterGroup({
      maxClusterRadius: 50, // Максимальный радиус кластера
      showCoverageOnHover: true, // Не показывать покрытие кластера при наведении
    });


    this.map.on('move', () => {
      this.updateOverlayPositions();
    });
    this.map.on('zoomstart', () => {
      this.iconDisplay = false;
      this.updateOverlayPositions();
      this.updateOverlaySizes();
    });
    this.map.on('zoom', () => {
      this.updateOverlayPositions();
      this.updateOverlaySizes();
    });
    this.map.on('zoomend', () => {
      this.iconDisplay = true;
      this.updateOverlayPositions();
    });
    this.updateOverlayPositions();
    this.updateOverlaySizes();
    

    // const legends = [
    //   L.marker([29.372601506681402, 56.43676757812501], {icon:  L.divIcon({
    //       className: 'fixed-icon',
    //       html: document.getElementById('fist')?.innerHTML,
    //       iconSize: [50, 50], // Размер контейнера
    //       iconAnchor: [25, 25] // Точка привязки
    //     }), title: "legend-fist"}),
    // ];
    //
    // this.legends = legends;

    this.panoramas = [
      L.marker([79.9, 60], {icon: this.panoramaIcon, title: "panoramaId-0"}), // most
      L.marker([75, 51.9], {icon: this.panoramaIcon, title: "panoramaId-1"}), // moskovskiy
      L.marker([78.45, 52.75], {icon: this.panoramaIcon, title: "panoramaId-2"}), // vspolie
      L.marker([33.2, -112.1], {icon: this.panoramaIcon, title: "panoramaId-3"}), // bui
      L.marker([78.2, 97.55], {icon: this.panoramaIcon, title: "panoramaId-4"}), // vologda
      L.marker([54.15, -128.8], {icon: this.panoramaIcon, title: "panoramaId-5"}), // cherepovec
    ];

    const points = [
      L.marker([23.684774166883756, -155.08300781250003], {icon: this.daysIcon, title: "timelineId-14"}),
      L.marker([63.860035895395306, -85.86914062500001], {icon: this.actionsIcon, title: "timelineId-14"}),
      L.marker([63.724183392123315, -84.85839843750001], {icon: this.boevoiIcon, title: "timelineId-14"}),
      L.marker([76.46806271128288, -49.05395507812501], {icon: this.achievmentIcon, title: "timelineId-14"}),
      L.marker([75.6340849612546, -50.55908203125001], {icon: this.air_strikeIcon, title: "timelineId-14"}),
      L.marker([64.01930937082838, -86.36352539062501], {icon: this.achievmentIcon, title: "timelineId-14"}),
      L.marker([76.81578187834086, -79.36523437500001], {icon: this.buildingIcon, title: "timelineId-14"}),
// L.marker([77.02955867503073, -78.61816406250001], {icon: this.infrastructureIcon, title: "timelineId-14"}),
      L.marker([75.12950410894491, -53.92089843750001], {icon: this.daysIcon, title: "timelineId-14"}),
      L.marker([39.757879992021756, -45.83496093750001], {icon: this.infrastructureIcon, title: "timelineId-14"}),
// L.marker([39.36827914916014, -46.1865234375], {icon: this.infrastructureIcon, title: "timelineId-14"}),
      L.marker([53.30462107510271, -78.13476562500001], {icon: this.recon_trainIcon, title: "timelineId-14"}),
      L.marker([54.92714186454645, -81.21093750000001], {icon: this.infrastructureIcon, title: "timelineId-14"}),
      L.marker([40.54720023441049, -48.47167968750001], {icon: this.infrastructureIcon, title: "timelineId-14"}),
      L.marker([53.09402405506328, -78.4423828125], {icon: this.infrastructureIcon, title: "timelineId-14"}),
// L.marker([52.696361078274485, -78.17871093750001], {icon: this.infrastructureIcon, title: "timelineId-14"}),
      L.marker([53.51418452077113, -76.81640625000001], {icon: this.achievmentIcon, title: "timelineId-14"}),
      L.marker([69.76375692223178, -72.11425781250001], {icon: this.actionsIcon, title: "timelineId-14"}),
      L.marker([72.43553464712416, -64.86328125000001], {icon: this.air_strikeIcon, title: "timelineId-14"}),
      L.marker([74.913708156753, -53.74511718750001], {icon: this.infrastructureIcon, title: "timelineId-14"}),
// L.marker([75.33115771680923, -51.50390625000001], {icon: this.infrastructureIcon, title: "timelineId-14"}),
      L.marker([76.25825951133778, -48.3837890625], {icon: this.infrastructureIcon, title: "timelineId-14"}),
      L.marker([76.51681887717322, -55.72265625], {icon: this.daysIcon, title: "timelineId-14"}),
// L.marker([41.244772343082076, -49.48242187500001], {icon: this.daysIcon, title: "timelineId-14"}),
      L.marker([65.85675647909318, -144.75585937500003], {icon: this.air_strikeIcon, title: "timelineId-14"}),
      L.marker([43.42100882994726, -117.29003906250001], {icon: this.air_strikeIcon, title: "timelineId-14"}),
// L.marker([78.933477933048820, 46.665429687500010], {icon: this.infrastructureIcon, title: "timelineId-14"}),
      L.marker([77.633477933048820, 46.665429687500010], {icon: this.reserveIcon, title: "timelineId-14"}),
      L.marker([78.77634845965974, 91.58203125000001], {icon: this.infrastructureIcon, title: "timelineId-14"}),
      L.marker([75.097779424116000, 54.143750000000010], {icon: this.daysIcon, title: "timelineId-14"}),
      L.marker([75.497779424116000, 55.743750000000010], {icon: this.specialIcon, title: "timelineId-14"}),
      L.marker([38.7283759182398, -120.948486328125], {icon: this.achievmentIcon, title: "timelineId-14"}),
      L.marker([39.926588421909436, -45.53833007812501], {icon: this.infrastructureIcon, title: "timelineId-14"}),
// L.marker([40.613952441166596, -48.31787109375001], {icon: this.infrastructureIcon, title: "timelineId-14"}),
      L.marker([77.76758238272801, 99.36035156250001], {icon: this.buildingIcon, title: "timelineId-14"}),
      L.marker([56.70450561416937, -132.60498046875003], {icon: this.air_strikeIcon, title: "timelineId-14"}),
      L.marker([54.87660665410869, -129.96826171875003], {icon: this.air_strikeIcon, title: ""}),
      L.marker([53.09402405506328, -103.75488281250001], {icon: this.air_strikeIcon, title: ""}),
      L.marker([42.00032514831623, -117.64160156250001], {icon: this.air_strikeIcon, title: ""}),
      L.marker([22.460563309048314, -155.783007812500030], {icon: this.achievmentIcon, title: ""}),
// L.marker([22.760563309048314, -155.883007812500030], {icon: this.achievmentIcon, title: ""}),
      L.marker([74.853397920304810, 56.912304687500010], {icon: this.boevoiIcon, title: ""}),
      L.marker([74.953397920304810, 57.112304687500010], {icon: this.achievmentIcon, title: ""}),
      L.marker([42.87596410238256, -116.41113281250001], {icon: this.air_strikeIcon, title: ""}),
      L.marker([43.929549935614595, -115.57617187500001], {icon: this.air_strikeIcon, title: ""}),
      L.marker([39.50404070558415, -119.97070312500001], {icon: this.air_strikeIcon, title: ""}),
      L.marker([57.302789656350086, -132.97851562500003], {icon: this.air_strikeIcon, title: ""}),
      L.marker([63.23362741232569, -138.42773437500003], {icon: this.air_strikeIcon, title: ""}),
      L.marker([60.8663124746226, -136.31835937500003], {icon: this.air_strikeIcon, title: ""}),
      L.marker([51.781435604431195, -106.06201171875001], {icon: this.air_strikeIcon, title: ""}),
      L.marker([61.60639637138628, -137.39501953125003], {icon: this.air_strikeIcon, title: ""}),
// L.marker([62.684228187998514, -137.98828125000003], {icon: this.air_strikeIcon, title: ""}),
      L.marker([60.261617082844616, -136.16455078125003], {icon: this.air_strikeIcon, title: ""}),
// L.marker([72.08743247624157, -152.31445312500003], {icon: this.evacuationIcon, title: ""}),
      L.marker([78.54304353589549, 95.5810546875], {icon: this.evacuationIcon, title: ""}),
      L.marker([56.486761752490885, -132.05566406250003], {icon: this.air_strikeIcon, title: ""}),
      L.marker([38.03078569382294, -120.98144531250001], {icon: this.air_strikeIcon, title: ""}),
      L.marker([38.41055825094609, -111.88476562500001], {icon: this.air_strikeIcon, title: ""}),
      L.marker([70.25945200030641, -151.56738281250003], {icon: this.air_strikeIcon, title: ""}),
      L.marker([39.842286020743394, -119.09179687500001], {icon: this.air_strikeIcon, title: ""}),
      L.marker([48.748945343432936, -110.12695312500001], {icon: this.air_strikeIcon, title: ""}),
// L.marker([59.06315402462662, -135.52734375000003], {icon: this.air_strikeIcon, title: ""}),
      L.marker([58.58543569119917, -135.35156250000003], {icon: this.air_strikeIcon, title: ""}),
      L.marker([66.20487571945456, -145.72265625000003], {icon: this.air_strikeIcon, title: ""}),
      L.marker([78.87852828127829, 44.736328125], {icon: this.buildingIcon, title: ""}),
      L.marker([54.181726602390945, -128.72680664062503], {icon: this.evacuationIcon, title: ""}),
// L.marker([54.04648911335576, -128.61694335937503], {icon: this.daysIcon, title: ""}),
      L.marker([51.316880504045876, -121.8603515625], {icon: this.air_strikeIcon, title: ""}),
      L.marker([64.05297838071347, -140.20751953125003], {icon: this.air_strikeIcon, title: ""}),
      L.marker([64.70380028388504, -142.10815429687503], {icon: this.air_strikeIcon, title: ""}),
      L.marker([64.23026938253825, -140.81176757812503], {icon: this.air_strikeIcon, title: ""}),
      L.marker([77.80477074199557, 98.12988281250001], {icon: this.buildingIcon, title: ""}),
      L.marker([67.0074280854991, -146.72241210937503], {icon: this.air_strikeIcon, title: ""}),
// L.marker([65.13687800930502, -143.10791015625003], {icon: this.air_strikeIcon, title: ""}),
      L.marker([65.4354348392272, -143.78906250000003], {icon: this.air_strikeIcon, title: ""}),
      L.marker([53.56641415275043, -128.21044921875003], {icon: this.air_strikeIcon, title: ""}),
      L.marker([79.02171239525758, 52.99804687500001], {icon: this.daysIcon, title: ""}),
      L.marker([78.22002810013534, 93.38378906250001], {icon: this.evacuationIcon, title: ""}),
      L.marker([68.87143872335129, -151.30371093750003], {icon: this.actionsIcon, title: ""}),
      L.marker([68.9189095799366, -150.89721679687503], {icon: this.actionsIcon, title: ""}),
      L.marker([68.89123063152091, -150.54565429687503], {icon: this.actionsIcon, title: ""}),
      L.marker([68.7323988003523, -149.88647460937503], {icon: this.infrastructureIcon, title: ""}),
      L.marker([68.60451335384136, -149.96337890625003], {icon: this.air_strikeIcon, title: ""}),
      L.marker([66.00908582293678, -145.55786132812503], {icon: this.air_strikeIcon, title: ""}),
      L.marker([62.77483725887553, -138.77929687500003], {icon: this.air_strikeIcon, title: ""}),
      L.marker([55.62799595426723, -131.96777343750003], {icon: this.air_strikeIcon, title: ""}),
      L.marker([41.44272637767212, -118.87207031250001], {icon: this.air_strikeIcon, title: ""}),
      L.marker([66.9042163330748, -147.10693359375003], {icon: this.daysIcon, title: ""}),
      L.marker([76.67978490310692, 109.29199218750001], {icon: this.infrastructureIcon, title: ""}),
      L.marker([78.19757802282507, 56.60156250000001], {icon: this.daysIcon, title: ""}),
      L.marker([77.86034459764656, 92.548828125], {icon: this.reserveIcon, title: ""}),
      L.marker([77.71159036383129, 95.537109375], {icon: this.achievmentIcon, title: ""}),
      L.marker([78.54304353589549, 98.83300781250001], {icon: this.boevoiIcon, title: ""}),
      L.marker([77.97990023317647, 100.19531250000001], {icon: this.specialIcon, title: ""}),
      L.marker([77.18643383938453, 96.8115234375], {icon: this.air_strikeIcon, title: ""}),
      L.marker([78.48177997842906, 90.17578125000001], {icon: this.achievmentIcon, title: ""}),
      L.marker([71.95177764301071, -66.42333984375001], {icon: this.evacuationIcon, title: ""}),
      L.marker([63.607216680330794, -85.8251953125], {icon: this.evacuationIcon, title: ""}),
// L.marker([60.07580342475969, -135.87890625000003], {icon: this.evacuationIcon, title: ""}),
      L.marker([53.81362579235237, -129.50683593750003], {icon: this.infrastructureIcon, title: ""}),
      L.marker([77.3318091852135, 103.71093750000001], {icon: this.infrastructureIcon, title: ""}),
// L.marker([48.45835188280866, -116.71875000000001], {icon: this.infrastructureIcon, title: ""}),
      L.marker([41.77131167976407, -123.71016714461197], {icon: this.evacuationIcon, title: ""}),
      L.marker([48.04870994288686, -112.36816406250001], {icon: this.infrastructureIcon, title: ""}),
      L.marker([48.019324184801185, -113.02734375000001], {icon: this.infrastructureIcon, title: ""}),
      L.marker([42.52069952914966, -117.14721679687501], {icon: this.daysIcon, title: ""}),
      L.marker([60.32150850738404, -136.71386718750003], {icon: this.disturbancesIcon, title: ""}),
      L.marker([59.98250201795759, -136.74682617187503], {icon: this.achievmentIcon, title: ""}),
      L.marker([78.60832631669345, 93.603515625], {icon: this.evacuationIcon, title: ""}),
      L.marker([77.06895356504106, 54.53613281250001], {icon: this.achievmentIcon, title: ""}),
      L.marker([78.47300170046985, 60.90820312500001], {icon: this.daysIcon, title: ""}),
      L.marker([47.754097979680026, -151.65527343750003], {icon: this.air_strikeIcon, title: ""}),
// L.marker([45.767522962149904, -147.91992187500003], {icon: this.air_strikeIcon, title: ""}),
// L.marker([44.33956524809713, -145.94238281250003], {icon: this.air_strikeIcon, title: ""}),
// L.marker([43.16512263158296, -142.99804687500003], {icon: this.air_strikeIcon, title: ""}),
// L.marker([42.87596410238256, -140.66894531250003], {icon: this.air_strikeIcon, title: ""}),
// L.marker([41.902277040963696, -138.25195312500003], {icon: this.air_strikeIcon, title: ""}),
// L.marker([39.16414104768742, -135.52734375000003], {icon: this.air_strikeIcon, title: ""}),
// L.marker([36.527294814546245, -135.70312500000003], {icon: this.air_strikeIcon, title: ""}),
      L.marker([34.813803317113155, -135.57128906250003], {icon: this.air_strikeIcon, title: ""}),
      L.marker([47.84265762816538, -146.68945312500003], {icon: this.air_strikeIcon, title: ""}),
// L.marker([52.29504228453735, -143.87695312500003], {icon: this.air_strikeIcon, title: ""}),
      L.marker([56.58369172128337, -146.82128906250003], {icon: this.air_strikeIcon, title: ""}),
      L.marker([36.70365959719456, -124.80468750000001], {icon: this.air_strikeIcon, title: ""}),
// L.marker([37.16031654673677, -122.91503906250001], {icon: this.air_strikeIcon, title: ""}),
// L.marker([36.94989178681327, -121.90429687500001], {icon: this.air_strikeIcon, title: ""}),
      L.marker([38.16911413556086, -120.93750000000001], {icon: this.air_strikeIcon, title: ""}),
      L.marker([36.03133177633189, -124.76074218750001], {icon: this.air_strikeIcon, title: ""}),
      L.marker([36.10237644873644, -125.37597656250001], {icon: this.reserveIcon, title: ""}),
      L.marker([39.19820534889482, -121.68457031250001], {icon: this.air_strikeIcon, title: ""}),
      L.marker([39.53793974517628, -120.32226562500001], {icon: this.air_strikeIcon, title: ""}),
      L.marker([39.462760664371830, -134.919726562500030], {icon: this.daysIcon, title: ""}),
      L.marker([39.362760664371830, -134.619726562500030], {icon: this.daysIcon, title: ""}),
      L.marker([45.82879925192134, -149.28222656250003], {icon: this.achievmentIcon, title: ""}),
      L.marker([29.53522956294847, -140.31738281250003], {icon: this.daysIcon, title: ""}),
      L.marker([34.08906131584996, -134.60449218750003], {icon: this.daysIcon, title: ""}),
      L.marker([79.60821469998169, 53.96484375000001], {icon: this.achievmentIcon, title: ""}),
      L.marker([79.94359476929425, 59.58984375000001], {icon: this.air_strikeIcon, title: ""}),
      L.marker([78.09829559916763, 59.37011718750001], {icon: this.achievmentIcon, title: ""}),
// L.marker([27.68352808378776, -143.34960937500003], {icon: this.daysIcon, title: ""}),
      L.marker([28.033197847676377, -132.12158203125003], {icon: this.achievmentIcon, title: ""}),
      L.marker([33.33970700424029, -127.50732421875001], {icon: this.air_strikeIcon, title: ""}),
      L.marker([37.61423141542417, -134.89013671875003], {icon: this.air_strikeIcon, title: ""}),
      L.marker([35.137879119634185, -125.72753906250001], {icon: this.air_strikeIcon, title: ""}),
      L.marker([41.244772343082076, -135.94482421875003], {icon: this.air_strikeIcon, title: ""}),
      L.marker([11.609193407938953, -85.1220703125], {icon: this.specialIcon, title: ""}),
      L.marker([27.059125784374068, -123.39843750000001], {icon: this.daysIcon, title: ""}),
      L.marker([11.243062041947772, -84.70458984375001], {icon: this.evacuationIcon, title: ""}),
      L.marker([33.137551192346145, -112.14843750000001], {icon: this.infrastructureIcon, title: ""}),
// L.marker([26.82407078047018, -123.35449218750001], {icon: this.achievmentIcon, title: ""}),
      L.marker([26.96124577052697, -122.67333984375001], {icon: this.disturbancesIcon, title: ""}),
      L.marker([26.41155054662258, -123.35449218750001], {icon: this.achievmentIcon, title: ""}),
      L.marker([39.637939745176280, -135.631835937500030], {icon: this.air_strikeIcon, title: ""}),
      L.marker([40.137939745176280, -136.031835937500030], {icon: this.air_strikeIcon, title: ""}),
      L.marker([25.997549919572112, -130.25390625000003], {icon: this.daysIcon, title: ""}),
      L.marker([11.081384602413062, -85.14404296875], {icon: this.achievmentIcon, title: ""}),
      L.marker([32.861132322810974, -112.07153320312501], {icon: this.air_strikeIcon, title: ""}),
      L.marker([32.657875736955305, -112.21435546875001], {icon: this.daysIcon, title: ""}),
      L.marker([32.648625783736726, -111.77490234375001], {icon: this.reserveIcon, title: ""}),
      L.marker([16.341225619207496, -131.83593750000003], {icon: this.achievmentIcon, title: ""}),
      L.marker([13.581920900545857, -131.83593750000003], {icon: this.air_strikeIcon, title: ""}),
      L.marker([18.145851771694467, -131.57226562500003], {icon: this.specialIcon, title: ""}),
      L.marker([17.895114303749143, -130.47363281250003], {icon: this.daysIcon, title: ""}),
      L.marker([13.32548488559795, -131.08886718750003], {icon: this.achievmentIcon, title: ""}),
      L.marker([16.762467717941604, -132.80273437500003], {icon: this.achievmentIcon, title: ""}),
      L.marker([17.014767530557833, -119.35546875000001], {icon: this.daysIcon, title: ""}),
// L.marker([17.35063837604883, -133.68164062500003], {icon: this.achievmentIcon, title: ""}),
      L.marker([16.341225619207496, -130.82519531250003], {icon: this.evacuationIcon, title: ""}),
      L.marker([15.919073517982426, -130.91308593750003], {icon: this.achievmentIcon, title: ""}),
      L.marker([52.72298552457069, 51.1083984375], {icon: this.infrastructureIcon, title: ""}),
// L.marker([62.83508901142283, 111.18164062500001], {icon: this.infrastructureIcon, title: ""}),
      L.marker([53.12040528310657, 54.88769531250001], {icon: this.infrastructureIcon, title: ""}),
      L.marker([62.83508901142283, 111.75292968750001], {icon: this.achievmentIcon, title: ""}),
// L.marker([61.14323525084058, 106.39160156250001], {icon: this.achievmentIcon, title: ""}),
// L.marker([60.95177680956699, 105.38085937500001], {icon: this.achievmentIcon, title: ""}),
      L.marker([61.54364147554998, 108.10546875000001], {icon: this.achievmentIcon, title: ""}),
      L.marker([62.61356210229029, 111.70898437500001], {icon: this.infrastructureIcon, title: ""}),
      L.marker([55.25407706707272, 78.75000000000001], {icon: this.infrastructureIcon, title: ""}),
      L.marker([40.463666324587685, -133.98925781250003], {icon: this.air_strikeIcon, title: ""}),
      L.marker([42.65012181368025, -15.996093750000002], {icon: this.infrastructureIcon, title: ""}),
      L.marker([44.18220395771566, 19.248046875000004], {icon: this.infrastructureIcon, title: ""}),
// L.marker([43.8028187190472, 19.423828125000004], {icon: this.infrastructureIcon, title: ""}),
      L.marker([52.696361078274485, 55.32714843750001], {icon: this.infrastructureIcon, title: ""}),
      L.marker([52.8823912222619, 52.86621093750001], {icon: this.infrastructureIcon, title: ""}),
      L.marker([54.36775852406841, 73.10302734375001], {icon: this.infrastructureIcon, title: ""}),
      L.marker([54.13669645687002, 67.56591796875001], {icon: this.infrastructureIcon, title: ""}),
      L.marker([44.84029065139799, 18.786621093750004], {icon: this.infrastructureIcon, title: ""}),
      L.marker([43.91372326852401, 18.918457031250004], {icon: this.infrastructureIcon, title: ""}),
      L.marker([42.35854391749705, -15.842285156250002], {icon: this.infrastructureIcon, title: ""}),
      L.marker([78.981779978429060, 47.077539062500010], {icon: this.achievmentIcon, title: ""}),
// L.marker([77.781779978429060, 46.877539062500010], {icon: this.achievmentIcon, title: ""}),
      L.marker([78.681779978429060, 47.277539062500010], {icon: this.air_strikeIcon, title: ""}),
      L.marker([78.381779978429060, 46.777539062500010], {icon: this.evacuationIcon, title: ""}),
      L.marker([79.381779978429060, 46.177539062500010], {icon: this.disturbancesIcon, title: ""}),
      L.marker([77.781779978429060, 47.677539062500010], {icon: this.disturbancesIcon, title: ""}),
// L.marker([77.581779978429060, 47.677539062500010], {icon: this.disturbancesIcon, title: ""}),
      L.marker([44.213709909702054, 17.885742187500004], {icon: this.infrastructureIcon, title: ""}),
      L.marker([43.929549935614595, 17.006835937500004], {icon: this.infrastructureIcon, title: ""}),
      L.marker([62.562983094503075, 111.11572265625001], {icon: this.achievmentIcon, title: ""}),
      L.marker([40.84706035607122, -48.44970703125001], {icon: this.achievmentIcon, title: ""}),
      L.marker([43.389081939117496, 6.50390625], {icon: this.achievmentIcon, title: ""}),
      L.marker([43.81867485545323, 18.654785156250004], {icon: this.buildingIcon, title: ""}),
// L.marker([42.52069952914966, -0.5273437500000001], {icon: this.buildingIcon, title: ""}),
      L.marker([52.37559917665913, 52.69042968750001], {icon: this.actionsIcon, title: ""}),
      L.marker([72.03328927451815, -66.33544921875001], {icon: this.infrastructureIcon, title: ""}),
// L.marker([80.32750594400994, -83.84765625000001], {icon: this.infrastructureIcon, title: ""}),
      L.marker([76.80073870685207, -78.88183593750001], {icon: this.daysIcon, title: ""}),
      L.marker([72.06038062953816, -67.06054687500001], {icon: this.daysIcon, title: ""}),
    ];


    const arts: any[] = [];


    // points.forEach(marker => {
    //   const art = articles.find(a => this.hasArticle(a, marker.getLatLng().lat, marker.getLatLng().lng));
    //   if (art) {
    //     const pnt = {
    //       "icon": marker.getIcon().options.className?.toUpperCase(),
    //       "latitude":  marker.getLatLng().lat,
    //       "longitude":  marker.getLatLng().lng,
    //       "chronologyId":  art.id,
    //     };
    //     const idx = arts.findIndex(v => v.id == art.id);
    //     if (idx > -1) {
    //       arts[idx].mapPoints.push(pnt);
    //     } else {
    //       const item = {
    //         orderNumber: art.id,
    //         title: art.title,
    //         subTitle: art.subTitle,
    //         timeLineId: art.timeLineId,
    //         text: art.text,
    //         mobilePosition: art.mobilePosition,
    //         mobileSize: art.mobileSize,
    //         position: art.position,
    //         size: art.size,
    //         mapPoints: [] as any,
    //         images: art.imgs?.map(v => getUrlImg(v)) ?? []
    //       };
    //       item.mapPoints.push(pnt);
    //       arts.push(item);
    //     }
    //     marker.options.title = 'articleId-' + art.id;
    //   } else {
    //     marker.options.title = 'noArticle';
    //   }
    // });
    // this.points = points;
  }
  
  filter(searchString?: string, articlesFromBack?: Article[]) {
    if (articlesFromBack) {
      const points: L.Marker[] = [];
      articlesFromBack?.forEach((art) => {
        art.mapPoints?.forEach(p => {
          const ptn =  L.marker(
              [p.latitude, p.longitude],
              {
                icon: this.setIcon(p.icon),
                title: 'articleId-' + p.chronologyId,
                alt: 'pointId-' + p.id
              });
          points.push(ptn);
        })
      });
      this.points = points;
    }
    this.group.clearLayers();
    let arr: number[] = [];
    if (searchString) {
      arr = searchInObjects(articlesFromBack ?? [], searchString).map(v => v.id);
    }
    this.points.forEach((point, i) => {
      const className = point.options.icon?.options.className ?? '';
      if (this.filterByTypes.includes('all') || this.filterByTypes.includes(className)) {
        if (searchString) {
          const id = Number(point.options.title?.replaceAll('articleId-', ''));
          if (id && arr.includes(id)) {
            point.on('click', () => {
              if (this.edit) {
                const pointData: PointData = new PointData();
                const art = articlesFromBack?.find(v =>
                    v.id == Number(point.options?.title?.replaceAll('articleId-', '')));
                if (art) {
                  const ptn = art.mapPoints?.find(p =>
                      p.id == Number(point.options?.alt?.replaceAll('pointId-', '')));
                  if (ptn) {
                    pointData.art = art;
                    pointData.point = ptn;
                    this.emitActiveEdit.emit(pointData);
                    this.startRippleEffect(point);
                  }
                }
              } else {
                console.log(point);
                this.emitActive.emit(point.options.title);
              }
            });
            this.group.addLayer(point);
          }
        } else {
          point.on('click', () => {
            if (this.edit) {
              const pointData: PointData = new PointData();
              const art = articlesFromBack?.find(v =>
                  v.id == Number(point.options?.title?.replaceAll('articleId-', '')));
              if (art) {
                const ptn = art.mapPoints?.find(p =>
                    p.id == Number(point.options?.alt?.replaceAll('pointId-', '')));
                if (ptn) {
                  pointData.art = art;
                  pointData.point = ptn;
                  this.emitActiveEdit.emit(pointData);
                  this.startRippleEffect(point);
                }
              }
            } else {
              this.emitActive.emit(point.options.title);
              this.startRippleEffect(point);
            }
          });
          this.group.addLayer(point);
        }
      }
    });

    this.panoramas.forEach((point) => {
      if (this.filterByTypes.includes('all') || this.filterByTypes.includes('panorama')) {
        point.on('click', () => {
          this.emitPanorama.emit(point.options.title);
          this.startRippleEffect(point);
        });
        this.group.addLayer(point);
      }
    });

    this.legends.forEach(legend => {
      this.map.addLayer(legend);
    })
    this.map.on('click', () => {
      this.stopRippleEffect();
    });
    this.map.addLayer(this.group);
  }


  private startRippleEffect(marker: L.Marker): void {
    if (this.currentMarker) {
      this.stopRippleEffect(); // Останавливаем предыдущий эффект
    }
    this.currentMarker = marker; // Устанавливаем текущий маркер
    this.createRipple(marker);
    this.rippleInterval = setInterval(() => {
      this.createRipple(marker);
    }, 900); // Интервал между волнами (в миллисекундах)
  }

  private createRipple(marker: L.Marker): void {
    const iconElement = marker.getElement();

    if (iconElement) {
      const ripple = document.createElement('div');
      ripple.className = 'ripple';
      iconElement.appendChild(ripple);

      ripple.addEventListener('animationend', () => {
        ripple.remove();
      });
    }
  }

  private stopRippleEffect(): void {
    clearInterval(this.rippleInterval); // Очищаем интервал
    this.rippleInterval = null; // Сбрасываем переменную интервала
    if (this.currentMarker) {
      const iconElement = this.currentMarker.getElement();
      if (iconElement) {
        const ripples = iconElement.getElementsByClassName('ripple');
        while (ripples.length > 0) { // Удаляем все оставшиеся волны
          ripples[0].remove();
        }
      }
      this.currentMarker = null; // Сбрасываем текущий маркер
    }
  }

  private hasArticle(article: Article, lat: number, lng: number) {
    return article.coordinates.find((c) => c[0] == lat && c[1] == lng) != null;
  }

  private updateOverlayPositions() {
    this.overlayPositions.forEach(pos => this.updateOverlayPosition(pos));
  }


  private updateOverlayPosition(pos: {
    top: number,
    left: number,
    width: number,
    height: number,
    lat: number,
    lng: number,
    icon: Icon
  }) {
    const point = this.map.latLngToContainerPoint(latLng(pos.lat, pos.lng)); // Замените на ваши координаты
    const radius = pos.width / 2; // Получаем радиус круга
    pos.top = point.y - radius;
    pos.left = point.x - radius;
  }

  private updateOverlaySizes() {
    this.overlayPositions.forEach(pos => this.updateOverlaySize(pos));
  }

  private updateOverlaySize(pos: {
        top: number,
        left: number,
        width: number,
        height: number,
        lat: number,
        lng: number,
        icon: Icon
      }
  ) {
    const zoomLevel = this.map.getZoom();
    let size;
    switch (zoomLevel) {
      case 0: size = 5; break;
      case 1: size = 10; break;
      case 2: size = 20; break;
      case 3: size = 40; break;
      case 4: size = 80; break;
      case 5: size = 160; break;
      case 6: size = 320; break;
      case 7: size = 640; break;
      default: size = 20; break;
    }
    pos.width = size;
    pos.height = size;
  }


  setIcon(key: string) {
    switch (key) {
      case 'MEDAL': {
        return this.boevoiIcon;
      }
      case 'TARGET': {
        return this.actionsIcon;
      }
      case 'BOMB': {
        return this.air_strikeIcon;
      }
      case 'FIST': {
        return this.daysIcon;
      }
      case 'GEAR': {
        return this.recon_trainIcon;
      }
      case 'HELMET': {
        return this.reserveIcon;
      }
      case 'ATTENTION': {
        return this.disturbancesIcon;
      }
      case 'CRANE': {
        return this.infrastructureIcon;
      }
      case 'ASHOKA': {
        return this.specialIcon;
      }
      case 'TRAIN': {
        return this.buildingIcon;
      }
      case 'STAR': {
        return this.achievmentIcon;
      }
      case 'EVACUATION': {
        return this.evacuationIcon;
      }
      default: {
        return this.boevoiIcon;
      }
    }
  }

  setIcons() {
    this.boevoiIcon = L.divIcon({
      className: 'medal',
      html: document.getElementById('medal')?.innerHTML,
      iconSize: [40, 40], // Размер контейнера
      iconAnchor: [20, 40] // Точка привязки
    });

    this.actionsIcon = L.divIcon({
      className: 'target',
      html: document.getElementById('target')?.innerHTML,
      iconSize: [40, 40], // Размер контейнера
      iconAnchor: [20, 40] // Точка привязки
    });

    this.air_strikeIcon = L.divIcon({
      className: 'bomb',
      html: document.getElementById('bomb')?.innerHTML,
      iconSize: [40, 40], // Размер контейнера
      iconAnchor: [20, 40] // Точка привязки
    });

    this.daysIcon = L.divIcon({
      className: 'fist',
      html: document.getElementById('fist')?.innerHTML,
      iconSize: [40, 40], // Размер контейнера
      iconAnchor: [20, 40] // Точка привязки
    });

    this.recon_trainIcon = L.divIcon({
      className: 'gear',
      html: document.getElementById('gear')?.innerHTML,
      iconSize: [40, 40], // Размер контейнера
      iconAnchor: [20, 40] // Точка привязки
    });

    this.reserveIcon = L.divIcon({
      className: 'helmet',
      html: document.getElementById('helmet')?.innerHTML,
      iconSize: [40, 40], // Размер контейнера
      iconAnchor: [20, 40] // Точка привязки
    });

    this.disturbancesIcon = L.divIcon({
      className: 'attention',
      html: document.getElementById('attention')?.innerHTML,
      iconSize: [40, 40], // Размер контейнера
      iconAnchor: [20, 40] // Точка привязки
    });

    this.infrastructureIcon = L.divIcon({
      className: 'crane',
      html: document.getElementById('crane')?.innerHTML,
      iconSize: [40, 40], // Размер контейнера
      iconAnchor: [20, 40] // Точка привязки
    });

    this.specialIcon = L.divIcon({
      className: 'ashoka',
      html: document.getElementById('ashoka')?.innerHTML,
      iconSize: [40, 40], // Размер контейнера
      iconAnchor: [20, 40] // Точка привязки
    });

    this.buildingIcon = L.divIcon({
      className: 'train',
      html: document.getElementById('train')?.innerHTML,
      iconSize: [40, 40], // Размер контейнера
      iconAnchor: [20, 40] // Точка привязки
    });

    this.achievmentIcon = L.divIcon({
      className: 'star',
      html: document.getElementById('star')?.innerHTML,
      iconSize: [40, 40], // Размер контейнера
      iconAnchor: [20, 40] // Точка привязки
    });

    this.evacuationIcon = L.divIcon({
      className: 'evacuation',
      html: document.getElementById('evacuation')?.innerHTML,
      iconSize: [40, 40], // Размер контейнера
      iconAnchor: [20, 40] // Точка привязки
    });

    this.panoramaIcon = L.divIcon({
      className: 'panorama',
      html: document.getElementById('panorama')?.innerHTML,
      iconSize: [40, 40], // Размер контейнера
      iconAnchor: [20, 40] // Точка привязки
    });
  }


  protected readonly Icons = Icons;
}
